import { render } from "./InvoiceComponent.vue?vue&type=template&id=bbfd11ae&scoped=true"
import script from "./InvoiceComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceComponent.vue?vue&type=script&lang=js"

import "./InvoiceComponent.vue?vue&type=style&index=0&id=bbfd11ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbfd11ae"]])

export default __exports__